import Typography from "@mui/material/Typography"

import { NoWrapTableCell } from "../../../common/components/tables/cells"
import { formatDateTime } from "../../../common/utils"
import { getCallDispositionLabel } from "../calling/callDispositions"

export function ConciergeDialCountCell({ lead }) {
  const count = lead.concierge_dial_count ?? 0
  return (
    <NoWrapTableCell sx={{ textAlign: "center" }}>
      {count > 0 ? count : "—"}
    </NoWrapTableCell>
  )
}

export function ConciergeLastDialedCell({ lead }) {
  return (
    <NoWrapTableCell title={lead.concierge_last_dialed_at || undefined}>
      {lead.concierge_last_dialed_at
        ? formatDateTime(lead.concierge_last_dialed_at)
        : "—"}
    </NoWrapTableCell>
  )
}

export function ConciergeLastDispositionCell({ lead }) {
  const label = lead.concierge_last_disposition
    ? getCallDispositionLabel(lead.concierge_last_disposition)
    : null
  return (
    <NoWrapTableCell title={label || undefined}>
      {label ? (
        <Typography variant="body2" noWrap>
          {label}
        </Typography>
      ) : (
        "—"
      )}
    </NoWrapTableCell>
  )
}
